"use client";

import { useCallback } from "react";
import { useRouter } from "@/i18n/navigation";
import { useTranslations } from "next-intl";
import { AutocompleteSearchBar } from "@/components/search/autocomplete-search-bar";

export function ShopsAllSearch() {
  const router = useRouter();
  const t = useTranslations("shops.all");

  const handleSubmit = useCallback(
    (term: string) => {
      if (!term.trim()) return;
      router.push(`/shops?search=${encodeURIComponent(term.trim())}`);
    },
    [router],
  );

  return (
    <AutocompleteSearchBar
      sources={["shops"]}
      onSubmit={handleSubmit}
      placeholder={t("searchPlaceholder")}
    />
  );
}
